import hyperdom from 'hyperdom'
import BasePaymentMethod from '../methods/basePaymentMethod.jsx'
import formatPrice from '../../../../packages/ui-helpers/formatPrice.js'

export default class Full extends BasePaymentMethod{
  constructor (payment, paymentMethods, standardPriceStrikeThroughAllowed) {
    super(payment)
    this.type = 'full'
    this.paymentMethods = paymentMethods
    this.standardPriceStrikeThroughAllowed = standardPriceStrikeThroughAllowed
  }

  eligible () {
    return (!!this.payment.booking.booking.paymentOptions.full && this.paymentMethods.eligible.length)
  }

  amount () {
    return this.payment.booking.booking.paymentOptions.full.amount
  }

  isPriceDiscount () {
    return this.payment.totalBeforeDiscount().amount - this.payment.booking.booking.paymentOptions.full.amount > 0
  }

  render () {
    return <label class={['o-choice-item payment-options__item', {
      'has-discounts': this.payment.anyDiscounts(),
      '-selected': this.payment.paymentOption() === this,
    }]}>
      <input type='radio' class='o-choice-item__radio' name='payment-type'
        binding={[this.payment.paymentOptions, 'selected']}
        value={this} />
      <div className='o-choice-item__content payment-option__container'>
        <div>
          <div className='payment-option__title'>
            <div className='payment-option__title__header'>Pay in full</div>
          </div>
        </div>
        <div>
          <div className='payment-option__price'>
            <div className='payment-option__price-val'>{formatPrice({
              currency: this.payment.departure.prices.currency,
              amount: this.payment.booking.booking.paymentOptions.full.amount,
            })}</div>
            {this.isPriceDiscount() ? <div className='payment-option__green-desc'>Save 10% for paying in full</div> : ''}
          </div>
        </div>
      </div>
      <div className={['payment-option__methods-container', {'show-expanded': this.payment.paymentOption() === this}]}>
        <div className='payment-options'>
          {
            this.payment.paymentOption() === this ? [
              this.paymentMethods.selected,
              this.paymentMethods.selected.renderTermsAndConditions(),
              this.paymentMethods.selected.renderPaymentSummary(),
            ] : undefined
          }
        </div>
      </div>
    </label>
  }

  renderDiscountRibbon () {
    const discount = this.payment.totalBeforeDiscount().amount - this.payment.booking.booking.paymentOptions.full.amount
    return discount > 0 ? <span className='ribbon -right room-option-item__ribbon'>Save
      {' '+formatPrice({
        amount: discount,
        currency: this.payment.departure.prices.currency,
      })}</span> : ''
  }
}
